<template>
  <div>
  <div v-if="showNotice ? showNotice : false">
        <!-- 通过设置 scrollable 属性开启滚动播放 -->
  <van-notice-bar left-icon="volume-o" scrollable :text="msgText" @click="showMsg" />
  <van-dialog confirmButtonColor="#008c8c" messageAlign="left" v-model="showDialog" :message="msgText"></van-dialog>
  </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props:{
    msgText: { type: String, required: false, default: '员工端上新了！'}, // 消息体
    showNotice: { type: Boolean, required: false, default: true}, // 是否展示通知
    click: { type: Boolean, required: false, default: false}, // 点击展开详细窗口是否禁用 默认禁用
  },
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    // 点击展开消息提示 如果禁用了就点开
    showMsg(){
      if(this.click=== true){
        this.showDialog = true;
      }
    }

  },
};
</script>
